export const autoCalcFields = ["SALDOC.DISC1PRC", "SALDOC.SUMAMNT"];
